import React from "react";
import { CheckStatusApprovalContainer } from "../../container/panelReports";

const CheckStatusApprovalScreen: React.FC<{}> = () => {
  return <CheckStatusApprovalContainer/>;
}

export default CheckStatusApprovalScreen;